import { EyeCloseIcon, EyeIcon } from "../../icons";
import "./SignInForm.css";

/** Password input in the flat Sovereign Emerald auth style — shared by the
 * reset-password and set-password pages. */
export default function AuthPasswordField({
  label,
  placeholder,
  value,
  onChange,
  show,
  toggleShow,
  error,
  disabled = false,
  hint,
}: {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (val: string) => void;
  show: boolean;
  toggleShow: () => void;
  error?: string;
  disabled?: boolean;
  hint?: string;
}) {
  return (
    <div className="w-full">
      <label className="block text-xs font-semibold text-[#2A1F17] mb-1.5 tracking-wide uppercase ml-1">
        {label}
      </label>
      <div
        className={`group relative flex items-center h-14 px-4 rounded-xl transition-all duration-300
          ${
            error
              ? "bg-red-50/70 border border-error-500 ring-2 ring-error-500/20"
              : "login-glass-input"
          }`}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="shrink-0"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.8125 8.75C7.8125 4.78045 11.0304 1.5625 15 1.5625C18.9695 1.5625 22.1875 4.78045 22.1875 8.75V10.1422C22.1875 10.2257 22.1766 10.3066 22.1561 10.3837C23.9512 11.0433 25.3504 12.4915 25.9441 14.3186C26.25 15.2601 26.25 16.4234 26.25 18.75C26.25 21.0766 26.25 22.2399 25.9441 23.1814C25.3259 25.0841 23.8341 26.5759 21.9314 27.1941C20.9899 27.5 19.8266 27.5 17.5 27.5H12.5C10.1734 27.5 9.0101 27.5 8.06865 27.1941C6.16591 26.5759 4.67414 25.0841 4.0559 23.1814C3.75 22.2399 3.75 21.0766 3.75 18.75C3.75 16.4234 3.75 15.2601 4.0559 14.3186C4.64957 12.4915 6.04879 11.0433 7.8439 10.3837C7.82341 10.3066 7.8125 10.2257 7.8125 10.1422V8.75ZM9.6875 10.0427C10.3997 10 11.2934 10 12.5 10H17.5C18.7066 10 19.6004 10 20.3125 10.0427V8.75C20.3125 5.81599 17.934 3.4375 15 3.4375C12.066 3.4375 9.6875 5.81599 9.6875 8.75V10.0427ZM15 15.3125C15.5177 15.3125 15.9375 15.7323 15.9375 16.25V21.25C15.9375 21.7678 15.5177 22.1875 15 22.1875C14.4823 22.1875 14.0625 21.7678 14.0625 21.25V16.25C14.0625 15.7323 14.4823 15.3125 15 15.3125Z"
            fill="#0B3B2E"
          />
        </svg>
        <input
          type={show ? "text" : "password"}
          placeholder={placeholder ?? label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="flex-1 bg-transparent border-none outline-none text-[#0B3B2E] placeholder-[#7C9286] text-sm h-full ml-3"
        />
        <button
          type="button"
          onClick={toggleShow}
          className="text-[#5A6B65] hover:text-[#076333] transition cursor-pointer"
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? <EyeIcon className="size-5" /> : <EyeCloseIcon className="size-5" />}
        </button>
      </div>
      {hint && !error && <p className="mt-1.5 text-xs text-[#5A6B65] ml-1">{hint}</p>}
      {error && <p className="mt-1.5 text-sm text-error-500 ml-1">{error}</p>}
    </div>
  );
}
